import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21.99 2H2v16h16l4 4-.01-20zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
}), 'CommentSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CommentSharp.js
// module id = 2891
// module chunks = 2